import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UiService } from '../../core/services/core.ui.service';
import { TagsModel } from '../../core/services/core.models.tags.component';

@Component({
  selector: 'gf-tags-display',
  template: `
    <gf-spinner style="height: 18px;" *ngIf="spinner && !tags"></gf-spinner>
    <div *ngIf="tags?.length" class="gf-tags-display-row" [class.gf-tags-display-row--labeled]="label">
        <span *ngIf="label" class="gf-tags-display-label">
            <span class="glyphicon glyphicon-tag" aria-hidden="true"></span>
            {{ label }}
        </span>
        <span class="label label-default" *ngFor="let tag of tags; let i = index" [style.background-color]="getTagColor(tag, i)">
            {{ tag }}
        </span>
    </div>
  `,
  styles: [`
    .gf-tags-display-row { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
    .gf-tags-display-row--labeled { padding: 4px 0 8px; border-bottom: 1px solid #eee; margin-bottom: 4px; }
    .gf-tags-display-label {
        font-size: .8em; font-weight: 600; text-transform: uppercase;
        letter-spacing: .04em; color: #888; white-space: nowrap;
        margin: 0; padding-right: 8px; flex: 0 0 auto;
    }
    .gf-tags-display-label .glyphicon { margin-right: 4px; }
    body.dark .gf-tags-display-row--labeled { border-bottom-color: #607185; }
    body.dark .gf-tags-display-label { color: #a7b3c2; }
  `],
})
export class TagsDisplayComponent implements OnInit, OnChanges {
  @Input() section!: string;
  @Input() refid!: string;
  @Input() spinner: boolean | undefined;
  @Input() label: string = '';

  tags: string[] | null = null;
  private lastSection: string | null = null;
  private lastRefId: string | null = null;

  constructor(private tagsModel: TagsModel, private uiService: UiService) {}

  ngOnInit() {
    this.loadTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.section && !changes.section.firstChange) ||
        (changes.refid && !changes.refid.firstChange)) {
      this.loadTags();
    }
  }

  private loadTags() {
    if (!this.section || !this.refid) {
      this.tags = [];
      this.spinner = false;
      return;
    }

    if (this.section === this.lastSection && this.refid === this.lastRefId) {
      return;
    }

    this.lastSection = this.section;
    this.lastRefId = this.refid;
    this.spinner = true;

    // Use the tags returned by load() rather than the shared this.tagsModel.tags field, which
    // another gf-tags-display instance could overwrite between resolution and read.
    this.tagsModel.load(this.section, +this.refid)
      .then((result: any) => {
        this.tags = (result && result.success && result.tags) ? result.tags.slice() : [];
        this.spinner = false;
      });
  }

  getTagColor(tag: string, index: number): string {
    return this.uiService.color.stringToClassColor(tag, index);
  }
}
